var jQuery=$=require('jquery');
    window.jQuery=jQuery;
    require('bootpag');
    module.exports = {
       // props: ['hotelId'],
        data:function(){
            return {
                country: '',
                province: '',
                city: '',
                hotelId: '',
                name: '',
                en: '',
                user:'',
                brand: '',
                type:0,
                typekey:0,
                star: 0,
                limit: 20,
                page: 1,
                total: 0,
                list: [],
                rows:0
            }
        },
        // compiled:function(){
        //     console.log('compiled')
        // },
        created:function(){
       
        },
        ready:function(){
            //console.log('readyready')
            var that=this;
            this.search('',0);
            this.$watch('country', function(val) {
                this.search(val);
            })
            this.$watch('province', function(val) {
                this.search(val);
            })
            this.$watch('city', function(val) {
                this.search(val);
            })
            this.$watch('hotelId', function(val) {
                this.search(val);
            })
            this.$watch('name', function(val) {
                this.search(val);
            })
            this.$watch('en', function(val) {
                this.search(val);
            })
            this.$watch('brand', function(val) {
                this.search(val);
            })
            this.$watch('type', function(val) {
                this.search(val);
            })
            this.$watch('star', function(val) {
                this.search(val);
            })
            this.$watch('limit', function(val) {
                this.search(val);
            })

            $('#callBackPager').bootpag({
               total: this.total,
                page:1,
                maxVisible: 10
                }).on("page", function(event, /* page number here */ num){
                    // console.log(1)
                that.search({page:num},1)
              });
            _flag_param = this.param;
        },
        methods:{
           search:function(val,rebuild){
                var url = this.baseApiPath;
                // console.log('searchsearch')
                allHotelData = {
                    method: 'hotel_search',
                    token: localStorage.token,
                    country: val&&val.country || this.country || '',
                    province: val&&val.province || this.province || '',
                    city: val&&val.city||this.city || '',
                    id: val&&val.hotelId||this.hotelId || '',
                    name: val&&val.name|| this.name || '',
                    en: val&&val.en||this.en || '',
                    brand: val&&val.brand||this.brand || '',
                    type:this.type,
                    star: val&&val.star||this.star || '',
                    limit: val&&val.limit||this.limit || '',
                    page: val&&val.page||this.page|| 1
                }
                var jqPromise = $.post(url, allHotelData);
                var realPromise = Promise.resolve(jqPromise);
                var that = this,rebuild=rebuild;
                realPromise.then(function(res) {
                    var res = JSON.parse(res)
                    if (res.code == 0) {
                        that.list = res.data['list'];
                        that.rows = res.data.page.rows;
                        that.total = res.data.page.total
                    } else {
                        alert(res['message'])
                    }
                    return res;
                })
                // .then(function(res){
                //    for(item in this.typelib){
                //     if(this.type==this.typelib[item]){
                //         this.typekey=item;
                //         }
                //      }
                // }
                .then(function(res) {
                   // console.log(rebuild)
                    if(!rebuild){
                            // console.log($('#callBackPager'))
                          $('#callBackPager').bootpag({
                            total: that.total,
                            page:1,
                            maxVisible: 10
                        }).on("page", function(event, /* page number here */ num){
                             that.search({page:num},1)
                        });
                    }
                    return res;
                })
            }
        },
        route:{
            activate:function(transtition){
                
                // this.search('',0);
                //window.scrollTo(0,0);
                transtition.next()
            },
            data:function(transtition){
                // console.log('datadata')
                this.search('',0);
                // this.search('',0);
                 // var url = this.baseApiPath,that=this;
                 //    var jqPromise = $.post(url,{method:'user_info',token:$.cookie('token')});
                 //    var realPromise = Promise.resolve(jqPromise);
                 //    realPromise.then(function(res){
                 //        var res=JSON.parse(res);
                 //        if(res.code!=0){
                 //            //window.location.href='login.html'
                 //            that.$root.$route.router.go('/login');
                 //        }
                 //    })
                 this.$dispatch('pageinfo','');
                 // this.search('',0);
                transtition.next();
            }
        }
    }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/list.vue
// module id = 77
// module chunks = 0